export const NO_DATA = 'N/A';
export const EMISSION_LABEL = 'Emission :';
export const CURRENT = 'Current : ';
export const YEAR = 'Year : ';
export const TARGET_LABEL = 'Target :';
export const FUEL_NAME_LABEL = 'Fuel Name :';
export const PERCENTAGE_LABEL = 'Percentage :';
export const UNIT = 'tCO₂e';
